import { render, staticRenderFns } from "./Chofer.vue?vue&type=template&id=159a3fb9"
import script from "./Chofer.vue?vue&type=script&lang=js"
export * from "./Chofer.vue?vue&type=script&lang=js"
import style0 from "./Chofer.vue?vue&type=style&index=0&id=159a3fb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports